import { AuxiliumComponent } from "../auxilium-component";

export default class Grid extends AuxiliumComponent {
	static observable = ["gap", "alignment"];

	constructor() {
		super();

		this.columns = parseInt(this.getAttribute("columns")) || 0;
		this.columnsSmall = parseInt(this.getAttribute("columns-sm")) || 0;
		this.columnsMedium = parseInt(this.getAttribute("columns-md")) || 0;
		this.columnsLarge = parseInt(this.getAttribute("columns-lg")) || 0;
		this.columnsExtraLarge = parseInt(this.getAttribute("columns-xl")) || 0;
		this.columnsExtraExtraLarge = parseInt(this.getAttribute("columns-xxl")) || 0;
	}

	parsedCallback() {
		if ([this.columns, this.columnsSmall, this.columnsMedium].some(x => x)) {
			if (this.columns) { Browser.AddCssRule(this, `--grid-columns: ${this.columns};`); };
			if (this.columnsSmall) { Browser.AddCssRule(this, `--grid-columns-sm: ${this.columnsSmall};`); };
			if (this.columnsMedium) { Browser.AddCssRule(this, `--grid-columns-md: ${this.columnsMedium};`); };
			if (this.columnsLarge) { Browser.AddCssRule(this, `--grid-columns-lg: ${this.columnsLarge};`); };
			if (this.columnsExtraLarge) { Browser.AddCssRule(this, `--grid-columns-xl: ${this.columnsExtraLarge};`); };
			if (this.columnsExtraExtraLarge) { Browser.AddCssRule(this, `--grid-columns-xxl: ${this.columnsExtraExtraLarge};`); };
		}

		const list = document.createElement("ul");

		[...this.childNodes ?? []].filter(x => x.nodeType !== Node.TEXT_NODE || x.textContent.trim())
			.forEach(item => this.addItem(item, list));

		this.appendChild(list);
	}

	addItem(item, list) {
		list ??= this.firstElementChild;

		if (!list) {
			list = this.appendChild(document.createElement("ul"));
		}

		const listItem = document.createElementWithContents("li", item);

		if (item.columnSpan) { Browser.AddCssRule(listItem, `--column-span: ${item.columnSpan}`); }
		if (item.rowSpan) { Browser.AddCssRule(listItem, `--row-span: ${item.rowSpan}`); }

		list.appendChild(listItem);
	}
	
	addItems(items) {
		items.forEach(item => this.addItem(item));
	}
}
